import { readPlaygroundDisplaySettings } from "./chat-settings.defaults"
import type {
  PlaygroundChatContext,
  PlaygroundChatInstance,
  PlaygroundChatState
} from "./playgroundTypes"

/**
 * Create initial Playground chat state
 */
export const createInitialState = (): PlaygroundChatState => ({
  activeChatId: null,
  selectedAgentId: null,
  chats: {},
  metadata: {
    chatIds: [],
    currentPage: 1,
    totalPages: 0,
    totalChats: 0,
    isLoading: false,
    error: null,
    newlyCreatedChatId: null,
    hasNextPage: false,
    isLoadingChatList: false,
    isLoadingChatHistory: false,
    chatListError: null
  }
})

/**
 * Create a new playground chat instance
 *
 * @param chatId - Chat UUID (pre-generated or from URL)
 * @param context - Playground context with agentId and optional chatRoomId
 * @param isNew - Whether this is a new chat (true) or an existing one being opened (false)
 * @returns New chat instance with isNew flag set based on context
 */
export const createChatInstance = (
  chatId: string,
  context?: PlaygroundChatContext,
  isNew = true
): PlaygroundChatInstance => ({
  id: chatId,
  isNew,
  messages: [],
  isLoadingMessages: false,
  streamingMessages: {},
  isSendingMessage: false,
  shouldShowDynamicWhitespace: false,
  unreadCount: 0,
  lastAccessedAt: Date.now(),
  context,
  createdAt: Date.now(),
  settings: readPlaygroundDisplaySettings(),
  topic: null,
  hasMoreHistory: false,
  isLoadingMoreMessages: false,
  messagesLoaded: false
})
